import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import Storage from "@/app/core/util/Storage";
import { CPFValidator, CheckUserData, PasswordIsStrong, UserType, UserTypeObj, ValidaCNPJ } from "@/app/core/util/helpers/UserHelper";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import { toast } from "react-toastify";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import InputMask from "react-input-mask";
import OnDataChange from "@/app/core/util/helpers/HandleChange";
import { AccountController } from "@/app/core/base/controllers/AccountController";
import { PhoneController } from "@/app/core/base/controllers/PhoneController";
import { CompanyController } from "@/app/core/base/controllers/CompanyController";

export default function LegalPersonRegister({ companyId }) {
  const [step, setStep] = useState(1);
  const [data, setData] = useState(AccountController.BaseModel);
  const [customer, setCustomer] = useState({ exist: false });
  const [fieldStatus, setFieldStatus] = useState("");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    loadPresentation()
  }, [companyId])

  function loadPresentation() {
    if (companyId != undefined) {
      CompanyController.Get(companyId, res => {
        console.log("Informação", { ...customer, exist: true, ...res })
        setCustomer({ ...customer, exist: true, ...res });
        setStep(3);
      })
    }
  }

  function preSave() {
    if (data != undefined && data.firstName !== undefined) {
      Storage.setRegisterUserData(data);
    }
  }

  useEffect(() => {
    preSave();
  }, [data])

  function handleChange(evt, type) {
    setData(OnDataChange(data, evt, type));
  }

  function handleCustomerChange(evt, type) {
    setCustomer(OnDataChange(customer, evt, type));
    if (evt.target.name == "document" && evt.target.value.length == 14) {
      CompanyController.Search(evt.target.value, res => {
        if (res.length > 0) {
          setCustomer({ ...customer, exist: true, document: evt.target.value, ...res[0] });
        }
      })
    }
  }

  async function registerUser(e) {
    if (e != undefined) {
      e.preventDefault();
    }
    if (data.password != data.passwordConfirm) {
      toast.error(Translate(Message.Account.PasswordDiferent), {
        position: toast.POSITION.BOTTOM_RIGHT
      });
      setFieldStatus("is-invalid");
    } else if (!PasswordIsStrong(data.password)) {
      toast.error(Translate(Message.Account.WeakPassword), {
        position: toast.POSITION.BOTTOM_RIGHT
      });
      setFieldStatus("is-invalid");
    } else if (data.terms != true) {
      toast.error(Translate(Message.Account.TermsNeeded), {
        position: toast.POSITION.BOTTOM_RIGHT
      });
    } else {
      const checkAccount = CheckUserData(data);

      // if (data.type == UserTypeObj.Person && !CPFValidator(data.document) && ) {
      //   toast.error(Translate(Message.Account.InvalidDoc), {
      //     position: toast.POSITION.BOTTOM_RIGHT
      //   });
      //   return;
      // }

      if (checkAccount.error === true) {
        console.log("Faltou mesmo", data, checkAccount);
        toast.error(checkAccount.message, {
          position: toast.POSITION.BOTTOM_RIGHT
        });
      } else {
        AccountController.Register({ ...data, documentType: data.type }, res => {

          let basePhone = PhoneController.BaseModel;
          basePhone.countryCode = "55";
          basePhone.areaCode = "11";
          basePhone.number = data.phone;
          basePhone.userId = res.id;

          Storage.setUserData({ ...res });
          setTimeout(() => {
            AccountController.Get(res.userId, async response => {
              localStorage.removeItem("register_user_data");
              toast.success(Translate(Message.Account.Welcome), {
                position: toast.POSITION.BOTTOM_RIGHT
              })

              Storage.setUserData({ ...res, ...response });
              if (data.type == UserTypeObj.LegalPerson) {
                if (customer.id == undefined) {
                  await CompanyController.Insert(customer, companyRes => {
                    AccountController.ConnectCompany(res.userId, companyRes.id, true, res => { })
                  })
                } else {
                  AccountController.ConnectCompany(res.userId, customer.id, false, res => { })
                }
              }

              await PhoneController.Insert({ ...basePhone, userId: res.userId }, result => {
                toast.success(Translate(Message.Account.SuccessfullyRegistred), {
                  position: toast.POSITION.BOTTOM_RIGHT
                });
                localStorage.removeItem("user_data");
                setStep(4);
                // window.location = "#/app";
              })
            })
          }, 500);
        })
      }
    }
  }

  function goLogin() {
    window.location = `#/`
  }

  function goToUser() {
    if (!customer.document ||
      !customer.name ||
      !customer.email ||
      !customer.phone) {
      toast.error(Message.PendingData, {
        position: toast.POSITION.BOTTOM_RIGHT
      });
    } else {
      // if (!ValidaCNPJ(customer.document)) {
      //   toast.error(Message.Account.InvalidDoc, {
      //     position: toast.POSITION.BOTTOM_RIGHT
      //   });
      //   return;
      // } else {
      // }
      setStep(step + 1);
    }
  }

  function goSecondStep() {
    if (data.type == undefined) {
      toast.error(Message.PendingData, {
        position: toast.POSITION.BOTTOM_RIGHT
      });
    } else {
      if (data.type == UserTypeObj.LegalPerson) {
        setStep(2);
      } else {
        setStep(3);
      }
    }
  }

  function changeStep() {
    switch (step) {
      case 1:
        return (
          <div>

            <p className="text-uppercase font-w700 font-size-sm">
              {Translate(Message.Register.Title)}
            </p>
            <div className="form-group">
              <span>{Translate(Message.Register.Type)}</span>
              <select className="form-control" name="type" value={data && data.type} onChange={evt => handleChange(evt, FieldTypeObj.Number)}>
                {UserType.map(item => (
                  <option value={item.value}>{item.name}</option>
                ))}
              </select>
            </div>

            <button className="btn btn-block btn-hero-lg btn-hero-success" onClick={() => goSecondStep()}>
              {Translate(Message.Advance)}
            </button>
            <button className="btn btn-block btn-hero-lg btn-hero-white" onClick={() => goLogin()}>
              {Translate(Message.HaveAnAccount)}
            </button>
          </div>
        );
      case 2:
        return (
          <div>
            <p className="text-uppercase font-w700 font-size-sm">
              {Translate(Message.Register.RegisterCompany)}
            </p>

            <div class="form-group">
              <label class="d-block">Tipo de empresa</label>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" class="custom-control-input" id="nationality1"
                  name="nationality"
                  checked={customer && customer.isNational == true ? true : false}
                  onChange={evt => setCustomer({ ...customer, isNational: true })}
                />
                <label class="custom-control-label" for="nationality1">{Translate(Message.National)}</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" class="custom-control-input" id="nationality2"
                  name="nationality"
                  checked={customer && customer.isNational == false ? true : false}
                  onChange={evt => setCustomer({ ...customer, isNational: false })}
                />
                <label class="custom-control-label" for="nationality2">{Translate(Message.International)}</label>
              </div>
            </div>
            {customer && customer.isNational ?
              <div className="form-group">
                <span>*{Translate(Message.TaxId)}</span>
                <InputMask
                  mask="99.999.999/9999-99"
                  maskChar=""
                  type="text"
                  className="form-control"
                  id="advanced-filter-document"
                  name="document"
                  value={customer && customer.document}
                  placeholder="99.999.999/9999-99"
                  onChange={(event) => {
                    handleCustomerChange({
                      target: {
                        name: "document",
                        value: event.target.value.replace("/\D/g", ""),
                      },
                    });
                  }}
                />
              </div>
              :
              <div className="form-group">
                <span>*{Translate(Message.TaxId)}</span>
                <input
                  type="text"
                  className="form-control"
                  id="advanced-filter-document"
                  name="document"
                  value={customer && customer.document}
                  placeholder=""
                  onChange={evt => handleCustomerChange(evt)}
                />
              </div>
            }
            {/* <div className="form-group">
              <span>CNPJ</span>
              <InputMask
                mask="99.999.999/9999-99"
                maskChar=""
                type="text"
                className="form-control"
                id="advanced-filter-document"
                name="document"
                placeholder="99.999.999/9999-99"
                value={customer && customer.document}
                onChange={(event) => {
                  handleCustomerChange({
                    target: {
                      name: "document",
                      value: event.target.value.replace(/\D/g, ""),
                    },
                  });
                }}
              />
            </div> */}
            <div className="form-group">
              <span>{Translate(Message.Name)}</span>
              <input type="text" name="name" value={customer && customer.name} placeholder="Empresa LTDA" className="form-control" onChange={evt => handleCustomerChange(evt)} />
            </div>
            <div className="form-group">
              <span>{Translate(Message.ContactEmail)}</span>
              <input type="text" name="email" value={customer && customer.email} placeholder="email@empresa.com.br" className="form-control" onChange={evt => handleCustomerChange(evt)} />
            </div>
            <div className="form-group">
              <span>{Translate(Message.Phone)}</span>
              <input
                type="text"
                className="form-control"
                id="phone-company"
                name="phone"
                value={customer && customer.phone}
                onChange={(event) => {
                  handleCustomerChange({
                    target: {
                      name: "phone",
                      value: event.target.value,
                    },
                  });
                }}
              />
            </div>


            <button className="btn btn-block btn-hero-lg btn-hero-success" onClick={() => goToUser()}>
              {Translate(Message.Advance)}
            </button>
            <button className="btn btn-block btn-hero-lg btn-hero-white" onClick={() => setStep(1)}>
              {Translate(Message.GoBack)}
            </button>
          </div>
        );
      case 3:
        return (
          <div>
            <p className="text-uppercase font-w700 font-size-sm">
              {Translate(Message.Register.AccountInformation)}
            </p>
            <form onSubmit={e => registerUser(e)} autoComplete="off">
              {data && data.type == UserTypeObj.LegalPerson ?
                <div className="form-group">
                  <span>{Translate(Message.Payment.PaymentType)}</span>
                  <select className="form-control" name="paymentType" value={data && data.paymentType} onChange={evt => handleChange(evt, FieldTypeObj.Number)}>
                    <option value={null}>{Translate(Message.Select)}</option>
                    <option value={0}>{Translate(Message.Payment.DefaultPayment)}</option>
                    <option value={1}>{Translate(Message.Payment.Billed)}</option>
                  </select>
                </div>
                : ""}

              <div className="form-group">
                <span>{Translate(Message.Name)}</span>
                <input type="text" name="firstName" value={data && data.firstName} className="form-control" onChange={evt => handleChange(evt)} />
              </div>
              <div className="form-group">
                <span>{Translate(Message.Surname)}</span>
                <input type="text" name="lastName" value={data && data.lastName} className="form-control" onChange={evt => handleChange(evt)} />
              </div>

              <div className="form-group">
                <span>{Translate(Message.Phone)}</span>
                <input
                  type="text"
                  className="form-control"
                  id="phone-user"
                  name="userphone"
                  placeholder="(99) 99999-999999"
                  value={data && data.phone}
                  onChange={(event) => {
                    handleChange({
                      target: {
                        name: "phone",
                        value: event.target.value,
                      },
                    });
                  }} />
              </div>
              {customer && customer.isNational ?
                <div className="form-group">
                  <span>{Translate(Message.Id)}</span>
                  <InputMask
                    mask="999.999.999-99"
                    maskChar=""
                    type="text"
                    className="form-control"
                    id="advanced-filter-document"
                    name="document"
                    placeholder="999.999.999-99"
                    value={data && data.document}
                    onChange={(event) => {
                      handleChange({
                        target: {
                          name: "document",
                          value: event.target.value.replace(/\D/g, ""),
                        },
                      });
                    }}
                  />
                </div>
                :
                ""
              }
              <div className="form-group">
                <span>E-mail</span>
                <input type="email" name="email"
                  value={data && data.email} className="form-control" onChange={evt => handleChange(evt)} />
              </div>

              <div className="form-group">
                <span>{Translate(Message.Login.Password)}</span>
                <div className="input-group">
                  <input
                    type={visible === true ? "text" : "password"}
                    className={"form-control " + fieldStatus}
                    name="password"
                    value={data && data.password}
                    placeholder="Senha"
                    onChange={evt => handleChange(evt)} />
                  <div class="input-group-append">
                    <span class="input-group-text" onClick={() => setVisible(!visible)}>
                      <i className={
                        visible === true
                          ? "far fa-fw fa-eye"
                          : "far fa-fw fa-eye-slash"
                      } />
                    </span>
                  </div>
                </div>
              </div>
              <small className="">
                * {Translate(Message.Register.StrongPassword)}
              </small>
              <div className="form-group">
                <span>{Translate(Message.Login.ConfirmPassword)}</span>
                <div className="input-group">
                  <input
                    type={visible === true ? "text" : "password"}
                    className={"form-control " + fieldStatus}
                    name="passwordConfirm"
                    value={data && data.passwordConfirm}
                    placeholder="Senha"
                    onChange={evt => handleChange(evt)} />
                  <div class="input-group-append">
                    <span class="input-group-text" onClick={() => setVisible(!visible)}>
                      <i className={
                        visible === true
                          ? "far fa-fw fa-eye"
                          : "far fa-fw fa-eye-slash"
                      } />
                    </span>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <div className="custom-control custom-checkbox custom-control-primary">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id={"check"}
                    name={"terms"}
                    checked={data && data.terms}
                    onChange={(evt) =>
                      handleChange({ target: { name: "terms", value: evt.target.checked } }, FieldTypeObj.Bool)
                    }
                  />
                  <label
                    className="custom-control-label"
                    for={"check"}
                  >
                    <a href={`#/terms`} target="_blank" className="text-warning">
                      {Translate(Message.Register.AcceptTerms)}
                    </a>{" "}
                  </label>
                </div>
              </div>

              <button className="btn btn-block btn-hero-lg btn-hero-success" type="button" onClick={() => registerUser()}>
                {Translate(Message.Advance)}
              </button>
              <button className="btn btn-block btn-hero-lg btn-hero-white" type="button" onClick={() => setStep(1)}>
                {Translate(Message.GoBack)}
              </button>
            </form>
          </div>
        );
      case 4:
        return (
          <div className="text-center">
            <i className="si si-check fa-2x text-succcess" />
            <br />
            <h3 className="text-muted">{Translate(Message.Register.Success)}
              <br />
              {customer && customer.id != undefined ?
                <span>{Translate(Message.Register.CompanyExist)}</span>
                : ""}
            </h3>

            <button className="btn btn-block btn-hero-lg btn-hero-success" onClick={() => goLogin()}>
              <i className="si si-login" />  Login
            </button>
          </div>
        );
      default:
        return (
          <div>

          </div>
        );
    }
  }

  return (
    <div className="col-sm-8 col-xl-8">
      {step && changeStep()}
    </div>
  )
}